import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';

// Import util modules
import { intlShape, injectIntl, FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';

// Import shared components
import { Form, PrimaryButton } from '../../../../components';
import css from './EditListingLinksForm.module.css';
import RenderCustomLinks from '../../../AuthenticationPage/SignupForm/RenderCustomLinks';

const EditListingLinksFormComponent = props => (
  <FinalForm
    keepDirtyOnReinitialize
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const { className, handleSubmit, viewport, updateInProgress } = formRenderProps;

      const classes = classNames(css.root, className);
      const submitInProgress = updateInProgress;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <div className={css.defaultUserFields}>
            <RenderCustomLinks viewport={viewport} maxLinks={3} />
          </div>

          <div className={css.bottomWrapper}>
            <div className={css.formBtns}>
              <PrimaryButton className={css.submitBtn} type="submit" inProgress={submitInProgress}>
                <FormattedMessage id="EditListingLinksForm.save" />
              </PrimaryButton>
            </div>
          </div>
        </Form>
      );
    }}
  />
);

EditListingLinksFormComponent.defaultProps = {
  className: null,
  formId: 'EditListingLinksForm',
  fetchErrors: null,
  hasExistingListingType: false,
  listingFieldsConfig: [],
};

EditListingLinksFormComponent.propTypes = {
  className: string,
  formId: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  onListingTypeChange: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    createListingDraftError: propTypes.error,
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingLinksFormComponent);
